import React from "react";
import { createGetOptionsFunc } from "./extreact-style-params";
const hashToInt = function (str) {
  if (str === void 0) {
    str = "";
  }
  let int = 0;
  for (let i = 0; i < str.length; i++) {
    int += str.charCodeAt(i);
  }
  return int;
};
function getServerParams(props) {
  const items = props.items,
    _props$rawOptions = props.rawOptions,
    rawOptions = _props$rawOptions === void 0 ? props.options : _props$rawOptions;
  const itemsStr = items.slice(0, 20).map(item => hashToInt(item.mediaUrl) + "_" + (item.width || item.metaData.width) + "_" + (item.height || item.metaData.height)).join("|");
  const getOptions = createGetOptionsFunc(rawOptions);
  const hrefStr = "/_serverless/pro-gallery-native-layout-fixer/layoutCssNative?id=" + props.id + "&items=" + itemsStr + "&container=";
  return {
    hrefStr,
    getOptions
  };
}
function createSsrJs(props) {
  const _getServerParams = getServerParams(props),
    hrefStr = _getServerParams.hrefStr,
    getOptions = _getServerParams.getOptions;
  const embed = content => "\n  var ele = document.getElementById('" + ("pro-gallery-" + props.id) + "');\n  " + content + "\n  var isVertical = options.includes('layoutParams_structure_scrollDirection:\"VERTICAL\"');\n  var layoutFixerUrl =  '" + hrefStr + "' + pgMeasures.top + '_' + pgMeasures.width + '_' + pgMeasures.height + '_' + window.innerHeight + '&options=' + options;\n  document.getElementById('" + ("layout-fixer-style-" + props.id) + "').setAttribute('href', encodeURI(layoutFixerUrl));\n});\n\n  ";
  return embed("\n      var nativeComp = document.getElementById(\"" + props.id + "\"), nativeRect = nativeComp.getBoundingClientRect();\n      var pgMeasures = {top: nativeRect.top, width: nativeRect.width, height: Number(getComputedStyle(nativeComp).getPropertyValue(\"height\").replace(\"px\", \"\"))};\n      var options = (" + getOptions + ")(ele);\n    ");
}
export const LayoutFixer = props => {
  try {
    return /*#__PURE__*/React.createElement("div", {
      id: "layout-fixer-" + props.id + props.isPrerenderMode,
      key: "layout-fixer-" + props.id + props.isPrerenderMode,
      style: {
        display: "none"
      }
    }, /*#__PURE__*/React.createElement("link", {
      rel: "stylesheet",
      id: "layout-fixer-style-" + props.id
    }), /*#__PURE__*/React.createElement("script", {
      dangerouslySetInnerHTML: {
        __html: "try {\n            window.requestAnimationFrame(function() {\n              " + createSsrJs(props) + "\n        } catch (e) {\n          console.warn('Cannot set layoutFixer css', e);\n        }"
      }
    }));
  } catch (e) {
    return /*#__PURE__*/React.createElement("div", {
      id: "layoutFixerErrors",
      style: {
        display: "none"
      }
    }, e.toString());
  }
};
//# sourceMappingURL=layoutFixer.js.map